// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * First Responder — scoped visual styles.
 *
 * A faithful port of the approved prototype at
 * gravy-docs/notification-engine/first-responder-pilot/prototype/first_responder_page.html
 *
 * Tokens are lifted from tenant-admin/src/styles/{colors,typography}.ts, so
 * the page reads as part of the product, not a bolt-on. Every rule is nested
 * under a scoped class (this is a CSS module) so no bare element selector
 * leaks into the rest of the app.
 */

.iqPQsPMiVvtnln8MAsnS,
.y04LaWVfcwjBptznHTgK {
  --ghost: #f4f5f7;
  --white: #fff;
  --text: #091e42;
  --text-light: #344563;
  --text-lighter: #5e6c84;
  --text-lightest: #97a0af;
  --n-lightest: #ebecf0;
  --n-lighter: #dfe1e6;
  --a2: rgba(9, 30, 66, 0.02);
  --a4: rgba(9, 30, 66, 0.04);
  --a8: rgba(9, 30, 66, 0.08);
  --a12: rgba(9, 30, 66, 0.12);
  --theme: #45a735;
  --theme-dark: #37862a;
  --theme-bg: #eeffec;
  --blue-bg: #eaf1ff;
  --blue: #4785ff;
  --amber-bg: #f5f2dd;
  --amber: #dea83e;
  --red-bg: #ffdfd8;
  --red: #dc1515;
  --radius-card: 8px;
  --radius-btn: 4px;
  --shadow1: 0 3px 6px rgba(9, 30, 66, 0.08);
}

.iqPQsPMiVvtnln8MAsnS {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 16px 48px;
  background: var(--ghost);
  color: var(--text);
  font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto,
    sans-serif;
  font-size: 0.875rem;
  line-height: 1.5;
}
.iqPQsPMiVvtnln8MAsnS *,
.iqPQsPMiVvtnln8MAsnS *::before,
.iqPQsPMiVvtnln8MAsnS *::after {
  box-sizing: border-box;
}

._RkqzkcZwafRoIZ5LX8c {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 32px 0 0;
  gap: 24px;
  flex-wrap: wrap;
}
.Lz1fSHW9l4DcTL5mWoUN {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.01em;
}
.gxkkvJV8qaR5WL8ITlSi {
  color: var(--text-lighter);
  font-size: 0.875rem;
  margin-top: 4px;
}
.nUww7B5GQ1ijwOJoHuOF {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.yoHS3gk_hhkysYP4X4NO {
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.TgCNSHYwEubDGA6QkBzC {
  background: var(--white);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow1);
  width: 100%;
  overflow: hidden;
}
.AaTYFAhghW0lWyV0Zh9Q {
  padding: 20px 20px 0;
}
.AaTYFAhghW0lWyV0Zh9Q h3 {
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}
.Soqru8tj2e4vxXjqI3A1 {
  padding: 20px;
}
.Soqru8tj2e4vxXjqI3A1 + .Soqru8tj2e4vxXjqI3A1 {
  border-top: 1px solid var(--n-lightest);
}
.MF6Puco1HzKPsSXQV4m4 {
  background: var(--a2);
}

/* Badges — pill treatment */
.VFPDVSDQXcYwFTNV6Z0w {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  background: var(--a12);
  color: var(--text);
}
._MAks52NZYih2rWMI8h6 {
  background: var(--blue-bg);
  color: var(--blue);
}
.l8c7jz9MD6eQajCpGrB3 {
  background: var(--theme-bg);
  color: var(--theme);
}
.A3HFEC2ULt3oxCklpCwD {
  background: var(--amber-bg);
  color: var(--amber);
}
.bTW3uKe3pYcsJFeRuUYo {
  background: var(--red-bg);
  color: var(--red);
}

/* Buttons */
.ddkJ1VOHoblXV4NYFOzS {
  height: 36px;
  padding: 4px 18px;
  border-radius: var(--radius-btn);
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  border: 1px solid transparent;
  background: var(--theme);
  color: #fff;
}
.ddkJ1VOHoblXV4NYFOzS:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.nmo4D5owhES48iBDxZyG {
  background: #fff;
  border-color: var(--n-lighter);
  color: var(--text);
}
.nmo4D5owhES48iBDxZyG:hover:not(:disabled) {
  background: var(--a4);
}
.FYI1GEcx0ZzXBLg1UVGP {
  background: #fff;
  border-color: var(--red);
  color: var(--red);
}
.FYI1GEcx0ZzXBLg1UVGP:hover:not(:disabled) {
  background: var(--red-bg);
}
.u3DhueCPJ1yhb08_tIt8 {
  height: 28px;
  padding: 2px 12px;
  font-size: 0.75rem;
}
.UaAVjv9R_bwqsIfbwgpA {
  background: none;
  border: none;
  color: var(--blue);
  padding: 0;
  height: auto;
  text-decoration: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.75rem;
}
.UaAVjv9R_bwqsIfbwgpA:hover {
  text-decoration: underline;
}

/* Segmented mode toggle — per-state colour when active */
.e3rK6UGdhdCGvyclC1Oz {
  display: inline-flex;
  background: var(--n-lightest);
  border-radius: 6px;
  padding: 3px;
  gap: 3px;
}
.oQvK5TrI_0c7Na0BnM2_ {
  padding: 8px 20px;
  border: none;
  background: transparent;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  color: var(--text-lighter);
  letter-spacing: 0.05em;
  font-family: inherit;
  transition: all 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.oQvK5TrI_0c7Na0BnM2_:hover:not(.k4Xhv0ppGL_UbnERZbYw):not(.on3RLOK3ZAhEsegYj5q8) {
  color: var(--text);
  background: rgba(255, 255, 255, 0.5);
}
.oQvK5TrI_0c7Na0BnM2_.on3RLOK3ZAhEsegYj5q8 {
  box-shadow: 0 1px 3px rgba(9, 30, 66, 0.15);
}
.oQvK5TrI_0c7Na0BnM2_.BVeUFPxrSxT3753BRElq {
  background: var(--text);
  color: #fff;
}
.oQvK5TrI_0c7Na0BnM2_.KawrcAvqi59k4O9i57Rw {
  background: var(--amber);
  color: #fff;
}
.oQvK5TrI_0c7Na0BnM2_.k4Xhv0ppGL_UbnERZbYw {
  cursor: not-allowed;
  color: var(--text-lightest);
}

/* State indicator dot next to title */
.o9JfJLQgNioKypOYUuxN {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
}
.ceWhBRCjN5Ot5pKQZx8y {
  background: var(--text-lighter);
}
.gBOF7JcxvcO5yzm2x_hz {
  background: var(--amber);
  animation: VySJIqQkrqpYn2vLIcYG 2s ease-in-out infinite;
}
.XU3PTfLI2v_sbHWFzbSe {
  background: var(--theme);
  animation: VySJIqQkrqpYn2vLIcYG 2s ease-in-out infinite;
}

/* System / Mode status indicators (replaces the OFF|SHADOW|ON toggle) */
.dq0z8ainfNshCK84jHtq {
  display: flex;
  gap: 28px;
  align-items: center;
  padding: 7px 16px;
  border: 1px solid var(--n-lighter);
  border-radius: 6px;
  background: #fff;
}
.rZJz8vXwF1vK4U2OFnrg {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.PiWjHTd2LipqZOTm8cNk {
  font-size: 0.625rem;
  letter-spacing: 0.08em;
  color: var(--text-lightest);
  text-transform: uppercase;
}
.A_wt52HLZ1LbK9hif5oJ {
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: var(--text);
}
.J3MAhIUL9B2_w_5B2DFe {
  color: var(--theme-dark);
}
.OuanVmrvdzvFgxAmBsq9 {
  color: var(--text-lighter);
}
.wyXt9xICZwZS94LfYZCb {
  color: var(--text-light);
}

/* OFF | SHADOW | LIVE — display-only state indicator (a track with a filled
   pill on the current state). Not a control: Start/Stop lives on the button. */
.sRsuYJJ1ULqfEXYFAjRw {
  display: inline-flex;
  gap: 3px;
  padding: 4px;
  background: var(--n-lightest);
  border-radius: 9px;
}
.qdB8AtLbeuYnpe1c0Stz {
  padding: 9px 20px;
  border: none;
  background: transparent;
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: var(--text-lightest);
  cursor: default;
  transition: all 0.15s;
}
.de1OCLweOkiz8WlDhAE7 {
  box-shadow: 0 1px 3px rgba(9, 30, 66, 0.18);
  color: #fff;
}
/* OFF = neutral slate, SHADOW = amber (evaluating). LIVE never fills — locked. */
.fRNRcibr2Yj_2vhtaI4o {
  background: #42526e;
}
.w5jBGEtyZn3JLmZZeDMa {
  background: var(--amber);
}
.HZQhY3IjPEV1p7T_YYSD {
  color: var(--text-lightest);
}

/* Status line under the toggle */
.uRQvlaaac6WS_JqZe_HU {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
  font-size: 0.8125rem;
  font-weight: 500;
}
.uRQvlaaac6WS_JqZe_HU .hM1etvtBwl8xWGaHeoBb {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.dwKNkpc1zkVyd7MbM33j {
  color: var(--text-lighter);
}
.dwKNkpc1zkVyd7MbM33j .hM1etvtBwl8xWGaHeoBb {
  background: var(--text-lighter);
}
.in7TpFAQCK_Cb_g1oS2A {
  color: var(--amber);
}
.in7TpFAQCK_Cb_g1oS2A .hM1etvtBwl8xWGaHeoBb {
  background: var(--amber);
}
.kAPgPw6xzgtwl5hjsIF2 {
  color: var(--theme-dark);
}
.kAPgPw6xzgtwl5hjsIF2 .hM1etvtBwl8xWGaHeoBb {
  background: var(--theme);
}

/* Buttons with a leading icon */
.ahLu5qFd2GH4DJEVW0gN {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.ahLu5qFd2GH4DJEVW0gN svg {
  width: 15px;
  height: 15px;
}

/* KPI cards with icons */
.nvaT9ZlDqXVNSzHOrGXb {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.svnn9LCv4ITMmdF_QAq5 {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 28px 24px;
}
.svnn9LCv4ITMmdF_QAq5 + .svnn9LCv4ITMmdF_QAq5 {
  border-left: 1px solid var(--n-lightest);
}
.I5uz3H9FMnKrtAhgkPjR {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.I5uz3H9FMnKrtAhgkPjR svg {
  width: 22px;
  height: 22px;
}
.KC5OcbBLxl6rbiMZyPpA {
  background: var(--theme-bg);
  color: var(--theme);
}
.ll7gl4mklw4jXeF3UkQk {
  background: var(--blue-bg);
  color: var(--blue);
}
.mxyk3hmhxhTW4GXKP7rQ {
  background: var(--amber-bg);
  color: #c98a1e;
}
.MWNa94GvAOZD7nx_ES45 {
  background: var(--red-bg);
  color: var(--red);
}
.HmCK4L3FLwfnBIi4tksd {
  color: var(--text-lighter);
  font-size: 0.9375rem;
}
.XxMIzD6yx862ei3vkkPt {
  font-weight: 700;
  font-size: 1.875rem;
  line-height: 1.1;
  margin-top: 4px;
}
.EJ6fPo62znOhONnS9us9 {
  color: var(--red);
}
@media (max-width: 900px) {
  .nvaT9ZlDqXVNSzHOrGXb {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .svnn9LCv4ITMmdF_QAq5:nth-child(odd) {
    border-left: none;
  }
}

/* Config strip as its own soft card */
.widv50eVMeQd9xUIjvoe {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  border-radius: var(--radius-card);
  box-shadow: var(--shadow1);
  color: var(--text-lighter);
  font-size: 0.8125rem;
  flex-wrap: wrap;
}
.znXQTsZ0R2cChF11Ug8y {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--blue-bg);
  color: var(--blue);
  display: flex;
  align-items: center;
  justify-content: center;
}
.znXQTsZ0R2cChF11Ug8y svg {
  width: 15px;
  height: 15px;
}

/* Needs-attention icon */
.g1VbfMKg250EBgYtp3o4 {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--red-bg);
  color: var(--red);
  display: flex;
  align-items: center;
  justify-content: center;
}
.g1VbfMKg250EBgYtp3o4 svg {
  width: 22px;
  height: 22px;
}

.RYhUeEPLHzCrQ86DI8tL {
  font-size: 0.8125rem;
  padding: 10px 14px;
  border-radius: 6px;
  margin-top: 12px;
}
.N4D0maocV5GnypEqMW9d {
  background: var(--blue-bg);
  color: var(--text-light);
}
.sWYV30spXtOG8lsKKBGZ {
  background: var(--red-bg);
  color: var(--red);
}
@keyframes VySJIqQkrqpYn2vLIcYG {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Stats block */
.HRHbImO4Ffz98ZcvjqEb {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px 24px;
}
@media (max-width: 720px) {
  .HRHbImO4Ffz98ZcvjqEb {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.MUkrxKpmk0izmCtEW0yj {
  min-width: 0;
}
/* One line, always. The tile caption names the results window, and the full label
   ("since enabled Sep 14, 8:00 AM EDT") wrapped to two and three lines inside this 4-column
   grid: the four captions ended up different heights, the values under them left their shared
   baseline, and the row pushed the card open. The caption is shortened at the source too
   (Presentation/windowCaption.ts) — this clamp is the backstop for a long stat label in a narrow
   column, and every label that can hit it carries a \`title\` so the clamp never hides the text. */
.Uxyd6AhAnsUUMaZ0szQ5 {
  color: var(--text-lighter);
  font-size: 0.8125rem;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.BbqhQEwymDhF2ZhtHRjq {
  font-weight: 700;
  font-size: 1.75rem;
  line-height: 1.15;
  margin-top: 8px;
}
.H8HnQu5w37axwPtlVQ3g {
  color: var(--text-lighter);
  font-size: 0.75rem;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--n-lightest);
}
.goElx0UxWwAlzfunv56e {
  color: var(--red);
}
.xtNlC6bFI3dXixDsyqcz {
  color: var(--theme);
}

.Dvon1fkXPdZLwQwQsUH1 {
  color: var(--text-lighter);
}
.wYnmMmEEXZ4t9lUeiHuB {
  font-size: 0.75rem;
}
.dBy9lDKjT8BEJcnjNA25 {
  font-weight: 500;
}

/* Tables */
.xqp6da11VtevcO0IQelv {
  width: 100%;
  border-collapse: collapse;
}
.xqp6da11VtevcO0IQelv th {
  padding: 14px 12px 12px;
  color: var(--text-lighter);
  font-size: 0.75rem;
  font-weight: 500;
  text-align: left;
  vertical-align: bottom;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.xqp6da11VtevcO0IQelv th:first-child,
.xqp6da11VtevcO0IQelv td:first-child {
  padding-left: 20px;
}
.xqp6da11VtevcO0IQelv th:last-child,
.xqp6da11VtevcO0IQelv td:last-child {
  padding-right: 20px;
}
.xqp6da11VtevcO0IQelv td {
  padding: 16px 12px;
  font-size: 0.875rem;
  vertical-align: middle;
}
.xqp6da11VtevcO0IQelv tbody tr {
  box-shadow: inset 0 -1px 0 0 var(--a8);
}
.xqp6da11VtevcO0IQelv tbody tr.kF2Bu4pxrCaIQvPdKFlo:nth-child(even) {
  background: var(--a2);
}
.Zgv30rGKdaOU8JWJU4gv {
  cursor: pointer;
}
.Zgv30rGKdaOU8JWJU4gv:hover {
  background: var(--a4);
}

/* Filter chips */
.oncUpbSkKTMz3d6ZvTzO {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}
.BBdyGq8wWPA4Yi8wF0wP {
  padding: 6px 12px;
  border-radius: 9999px;
  border: 1px solid var(--n-lighter);
  background: #fff;
  cursor: pointer;
  font-size: 0.75rem;
  font-family: inherit;
  color: var(--text);
}
.BBdyGq8wWPA4Yi8wF0wP:hover {
  background: var(--a4);
}
.BBdyGq8wWPA4Yi8wF0wP:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}
.BBdyGq8wWPA4Yi8wF0wP:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.asiy6DkuC87C9y0cg8nU {
  background: var(--text);
  color: #fff;
  border-color: var(--text);
}
/* An active chip must stay dark on hover — without this, the generic
   .chip:hover (same specificity, declared earlier is overridden but a
   pseudo-class variant later wins) turned the background light while the
   label stayed white: white-on-white text. */
.asiy6DkuC87C9y0cg8nU:hover {
  background: var(--text);
}
/* Long dynamic client names wrap instead of overflowing. */
.BBdyGq8wWPA4Yi8wF0wP {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}
.fTBFkncxFmoSE0ao0FAF {
  color: var(--text-lighter);
  margin-left: 6px;
}
.asiy6DkuC87C9y0cg8nU .fTBFkncxFmoSE0ao0FAF {
  color: rgba(255, 255, 255, 0.7);
}

/* Collapsible cards */
.CJfjcYtspTPqLFLZE9Mz {
  background: var(--white);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow1);
}
.CJfjcYtspTPqLFLZE9Mz > summary {
  padding: 20px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 8px;
}
.CJfjcYtspTPqLFLZE9Mz > summary::-webkit-details-marker {
  display: none;
}
.CJfjcYtspTPqLFLZE9Mz > summary::before {
  content: '▸';
  color: var(--text-lighter);
  font-size: 0.75rem;
}
.CJfjcYtspTPqLFLZE9Mz[open] > summary::before {
  content: '▾';
}

/* Modal */
.y04LaWVfcwjBptznHTgK {
  position: fixed;
  inset: 0;
  background: rgba(9, 30, 66, 0.54);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px;
  overflow: auto;
  /* Must beat the Agency shell's sidebar/nav stacking (observed above 1300
     in-browser): with a lower value, sidebar links stay clickable "through"
     an open modal and navigate away. */
  z-index: 10000;
}
.nS4ogvr0tWTB2vUHMt4j {
  background: #fff;
  border-radius: var(--radius-card);
  box-shadow: 0 8px 16px rgba(9, 30, 66, 0.16);
  width: 100%;
  max-width: 900px;
}
.xOizhGeU26W8u8CqNFIy {
  max-width: 420px;
}
.l93dmGQEoGHkKOASVTIZ {
  padding: 20px;
  border-bottom: 1px solid var(--n-lightest);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}
.l93dmGQEoGHkKOASVTIZ h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  color: var(--theme);
}
.hN4bCULhQ9Q5LP5euot2 {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  color: var(--text-lighter);
  line-height: 1;
  padding: 0;
}

/* Eligibility checks */
.F4alnrInSo9CeBa0egT8 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 10px 24px;
}
.dJoKqAPO6ks1C7cjbX_w {
  display: flex;
  gap: 8px;
  align-items: baseline;
}
.JBYB5O4PobnfjUomKs_d {
  color: var(--red);
  font-weight: 500;
}
.ukJ8JCGfbVo_75NbsRze {
  color: var(--theme);
  font-weight: 700;
}
.eTd7rdJP0ZUFbQjzkkqw {
  color: var(--red);
  font-weight: 700;
}

/* Horizontal-scroll container so wide tables never break the page. */
.cV2JR15y9Yx5xRWjeAnR {
  overflow-x: auto;
  max-width: 100%;
}

/* The funnel stage the run is currently at. */
.yRgFNaWMmF5i8N0UQiam {
  color: var(--text);
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* Funnel */
.ocbfGao_2c7vyHajd4YO {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  color: var(--text-light);
}
.ocbfGao_2c7vyHajd4YO b {
  font-weight: 600;
  color: var(--text);
}
.dbOpLTIGeRF4OP6Ax9IM {
  color: var(--text-lightest);
}

/* Timeline */
.nVFCKeVXtZMBV_HLdCKh {
  list-style: none;
  margin: 0;
  padding: 0;
}
.nVFCKeVXtZMBV_HLdCKh li {
  display: flex;
  gap: 16px;
  padding: 6px 0;
}
.nVFCKeVXtZMBV_HLdCKh .QETBNtPpJGHtfT3e3Rhy {
  color: var(--text-lighter);
  font-variant-numeric: tabular-nums;
  min-width: 72px;
  font-size: 0.75rem;
  padding-top: 2px;
}

/* Signals / key-value grid */
.YVlTLLx0s3laGhsFXZrQ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 12px;
  background: var(--a2);
  padding: 16px 20px;
}
.topTdRKp1tPmVWEYWyx2 {
  background: none;
  padding: 0;
}
.YVlTLLx0s3laGhsFXZrQ .Ky9EP0_AAv700QZjpKov {
  color: var(--text-lighter);
  font-size: 0.75rem;
}
.YVlTLLx0s3laGhsFXZrQ .dgzXm0Rio_MzEjLuVG6U {
  font-weight: 500;
}

/* Safety invariant — belongs to the prototype visual language */
.GDpZV0SVHiEa0Q6d2llL {
  border-left: 3px solid var(--red);
}
.EV5Rq64WvgOuaHLjetkj {
  border-left: 3px solid var(--theme);
}
.dMmY3VKXQMN6GSNNplEQ {
  border-left: 3px solid var(--red);
}
.uZVUQLmMHuhhhDoVuydV {
  background: var(--red);
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  padding: 12px 16px;
  border-radius: var(--radius-card);
  margin-bottom: 16px;
}
.uZVUQLmMHuhhhDoVuydV span {
  font-weight: 400;
  font-size: 0.8125rem;
}

/* Reduced motion: content still updates (countdown text), but nothing
   animates or transitions. */
@media (prefers-reduced-motion: reduce) {
  .iqPQsPMiVvtnln8MAsnS *,
  .y04LaWVfcwjBptznHTgK * {
    animation: none !important;
    transition: none !important;
  }
}

/* --- Settings editor / audit / ranking-evidence additions (additive) --- */
.O6wS22CxwDfjTZRDGhM3 {
  border: 1px solid var(--n-lighter);
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 0.875rem;
  font-family: inherit;
  color: var(--text);
  background: #fff;
}
.O6wS22CxwDfjTZRDGhM3:focus-visible {
  outline: 2px solid var(--theme);
  outline-offset: 1px;
}
.yafq7YgoHToLytMn_1m9 {
  margin: 8px 0 0;
  padding-left: 20px;
  font-size: 0.875rem;
}
.yafq7YgoHToLytMn_1m9 li {
  margin-top: 6px;
}
.pmcFmimKJ5f7DLWX6lC9 {
  color: var(--text-light);
}
.pmcFmimKJ5f7DLWX6lC9 em {
  font-style: normal;
  font-size: 0.8125rem;
  color: var(--text-light);
}
.Ir22rM1OLT4SSsCUkU2s {
  background: rgba(9, 30, 66, 0.04);
  border-radius: 4px;
  padding: 8px 12px;
  display: inline-block;
}
.VPQB_RzFVcjl1Y1ePFSA {
  margin-top: 12px;
  padding: 10px 12px;
  border-left: 3px solid var(--red);
  background: rgba(222, 53, 11, 0.06);
  font-size: 0.875rem;
}
.Wk8YEGOvZ3VQmyh_40xD {
  max-width: 260px;
}

/* Job-title deep link in the modal header. Hover and keyboard focus get the
   SAME visible treatment: the previous pointer-only inline handlers never
   fired for keyboard users, so tabbing to the link showed no cue. */
.VHuuTh14h0pnW9uEWIem {
  color: inherit;
  text-decoration: none;
}
.VHuuTh14h0pnW9uEWIem:hover {
  text-decoration: underline;
}
.VHuuTh14h0pnW9uEWIem:focus-visible {
  text-decoration: underline;
  outline: 2px solid var(--blue);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Agency/FirstResponder/FirstResponder.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;;EAEE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB;cACY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;AACzC;AACA;EACE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,uDAAwC;AAC1C;AACA;EACE,wBAAwB;EACxB,uDAAwC;AAC1C;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;;AAEA;+EAC+E;AAC/E;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,2CAA2C;EAC3C,WAAW;AACb;AACA,iFAAiF;AACjF;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE,YAAY;AACd;AACA;;;;;iGAKiG;AACjG;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;AACA;;;6CAG6C;AAC7C;EACE,uBAAuB;AACzB;AACA,2DAA2D;AAC3D;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd;;uCAEqC;EACrC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,4CAA4C;EAC5C,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;6BAC6B;AAC7B;EACE;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,4EAA4E;AAC5E;EACE,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;;oEAEoE;AACpE;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":["/*\n * First Responder — scoped visual styles.\n *\n * A faithful port of the approved prototype at\n * gravy-docs/notification-engine/first-responder-pilot/prototype/first_responder_page.html\n *\n * Tokens are lifted from tenant-admin/src/styles/{colors,typography}.ts, so\n * the page reads as part of the product, not a bolt-on. Every rule is nested\n * under a scoped class (this is a CSS module) so no bare element selector\n * leaks into the rest of the app.\n */\n\n.page,\n.overlay {\n  --ghost: #f4f5f7;\n  --white: #fff;\n  --text: #091e42;\n  --text-light: #344563;\n  --text-lighter: #5e6c84;\n  --text-lightest: #97a0af;\n  --n-lightest: #ebecf0;\n  --n-lighter: #dfe1e6;\n  --a2: rgba(9, 30, 66, 0.02);\n  --a4: rgba(9, 30, 66, 0.04);\n  --a8: rgba(9, 30, 66, 0.08);\n  --a12: rgba(9, 30, 66, 0.12);\n  --theme: #45a735;\n  --theme-dark: #37862a;\n  --theme-bg: #eeffec;\n  --blue-bg: #eaf1ff;\n  --blue: #4785ff;\n  --amber-bg: #f5f2dd;\n  --amber: #dea83e;\n  --red-bg: #ffdfd8;\n  --red: #dc1515;\n  --radius-card: 8px;\n  --radius-btn: 4px;\n  --shadow1: 0 3px 6px rgba(9, 30, 66, 0.08);\n}\n\n.page {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 16px 48px;\n  background: var(--ghost);\n  color: var(--text);\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    sans-serif;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n.page *,\n.page *::before,\n.page *::after {\n  box-sizing: border-box;\n}\n\n.pageHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 32px 0 0;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n.title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n.subtitle {\n  color: var(--text-lighter);\n  font-size: 0.875rem;\n  margin-top: 4px;\n}\n.headerControls {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.content {\n  margin: 24px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.card {\n  background: var(--white);\n  border-radius: var(--radius-card);\n  box-shadow: var(--shadow1);\n  width: 100%;\n  overflow: hidden;\n}\n.cardHeader {\n  padding: 20px 20px 0;\n}\n.cardHeader h3 {\n  font-size: 1rem;\n  font-weight: 500;\n  margin: 0;\n}\n.section {\n  padding: 20px;\n}\n.section + .section {\n  border-top: 1px solid var(--n-lightest);\n}\n.sectionSubdued {\n  background: var(--a2);\n}\n\n/* Badges — pill treatment */\n.badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  background: var(--a12);\n  color: var(--text);\n}\n.blue {\n  background: var(--blue-bg);\n  color: var(--blue);\n}\n.green {\n  background: var(--theme-bg);\n  color: var(--theme);\n}\n.amber {\n  background: var(--amber-bg);\n  color: var(--amber);\n}\n.red {\n  background: var(--red-bg);\n  color: var(--red);\n}\n\n/* Buttons */\n.btn {\n  height: 36px;\n  padding: 4px 18px;\n  border-radius: var(--radius-btn);\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  border: 1px solid transparent;\n  background: var(--theme);\n  color: #fff;\n}\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.btnOutline {\n  background: #fff;\n  border-color: var(--n-lighter);\n  color: var(--text);\n}\n.btnOutline:hover:not(:disabled) {\n  background: var(--a4);\n}\n.btnDanger {\n  background: #fff;\n  border-color: var(--red);\n  color: var(--red);\n}\n.btnDanger:hover:not(:disabled) {\n  background: var(--red-bg);\n}\n.btnSm {\n  height: 28px;\n  padding: 2px 12px;\n  font-size: 0.75rem;\n}\n.btnPlain {\n  background: none;\n  border: none;\n  color: var(--blue);\n  padding: 0;\n  height: auto;\n  text-decoration: none;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.75rem;\n}\n.btnPlain:hover {\n  text-decoration: underline;\n}\n\n/* Segmented mode toggle — per-state colour when active */\n.modeToggle {\n  display: inline-flex;\n  background: var(--n-lightest);\n  border-radius: 6px;\n  padding: 3px;\n  gap: 3px;\n}\n.modeBtn {\n  padding: 8px 20px;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--text-lighter);\n  letter-spacing: 0.05em;\n  font-family: inherit;\n  transition: all 0.15s;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.modeBtn:hover:not(.locked):not(.active) {\n  color: var(--text);\n  background: rgba(255, 255, 255, 0.5);\n}\n.modeBtn.active {\n  box-shadow: 0 1px 3px rgba(9, 30, 66, 0.15);\n}\n.modeBtn.activeOff {\n  background: var(--text);\n  color: #fff;\n}\n.modeBtn.activeShadow {\n  background: var(--amber);\n  color: #fff;\n}\n.modeBtn.locked {\n  cursor: not-allowed;\n  color: var(--text-lightest);\n}\n\n/* State indicator dot next to title */\n.stateDot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n.stateDotOff {\n  background: var(--text-lighter);\n}\n.stateDotShadow {\n  background: var(--amber);\n  animation: pulse 2s ease-in-out infinite;\n}\n.stateDotRunning {\n  background: var(--theme);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n/* System / Mode status indicators (replaces the OFF|SHADOW|ON toggle) */\n.statusGroup {\n  display: flex;\n  gap: 28px;\n  align-items: center;\n  padding: 7px 16px;\n  border: 1px solid var(--n-lighter);\n  border-radius: 6px;\n  background: #fff;\n}\n.statusItem {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.statusKey {\n  font-size: 0.625rem;\n  letter-spacing: 0.08em;\n  color: var(--text-lightest);\n  text-transform: uppercase;\n}\n.statusVal {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  color: var(--text);\n}\n.statusRunning {\n  color: var(--theme-dark);\n}\n.statusStopped {\n  color: var(--text-lighter);\n}\n.modeLock {\n  color: var(--text-light);\n}\n\n/* OFF | SHADOW | LIVE — display-only state indicator (a track with a filled\n   pill on the current state). Not a control: Start/Stop lives on the button. */\n.segToggle {\n  display: inline-flex;\n  gap: 3px;\n  padding: 4px;\n  background: var(--n-lightest);\n  border-radius: 9px;\n}\n.segBtn {\n  padding: 9px 20px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  color: var(--text-lightest);\n  cursor: default;\n  transition: all 0.15s;\n}\n.segActive {\n  box-shadow: 0 1px 3px rgba(9, 30, 66, 0.18);\n  color: #fff;\n}\n/* OFF = neutral slate, SHADOW = amber (evaluating). LIVE never fills — locked. */\n.segActiveOff {\n  background: #42526e;\n}\n.segActiveShadow {\n  background: var(--amber);\n}\n.segLocked {\n  color: var(--text-lightest);\n}\n\n/* Status line under the toggle */\n.statusUnder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 10px;\n  font-size: 0.8125rem;\n  font-weight: 500;\n}\n.statusUnder .dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n}\n.statusOff {\n  color: var(--text-lighter);\n}\n.statusOff .dot {\n  background: var(--text-lighter);\n}\n.statusShadow {\n  color: var(--amber);\n}\n.statusShadow .dot {\n  background: var(--amber);\n}\n.statusLive {\n  color: var(--theme-dark);\n}\n.statusLive .dot {\n  background: var(--theme);\n}\n\n/* Buttons with a leading icon */\n.btnIcon {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.btnIcon svg {\n  width: 15px;\n  height: 15px;\n}\n\n/* KPI cards with icons */\n.kpiCard {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n.kpiItem {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 28px 24px;\n}\n.kpiItem + .kpiItem {\n  border-left: 1px solid var(--n-lightest);\n}\n.kpiIcon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.kpiIcon svg {\n  width: 22px;\n  height: 22px;\n}\n.kpiIconGreen {\n  background: var(--theme-bg);\n  color: var(--theme);\n}\n.kpiIconBlue {\n  background: var(--blue-bg);\n  color: var(--blue);\n}\n.kpiIconAmber {\n  background: var(--amber-bg);\n  color: #c98a1e;\n}\n.kpiIconRed {\n  background: var(--red-bg);\n  color: var(--red);\n}\n.kpiLabel {\n  color: var(--text-lighter);\n  font-size: 0.9375rem;\n}\n.kpiNum {\n  font-weight: 700;\n  font-size: 1.875rem;\n  line-height: 1.1;\n  margin-top: 4px;\n}\n.kpiNumAlert {\n  color: var(--red);\n}\n@media (max-width: 900px) {\n  .kpiCard {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .kpiItem:nth-child(odd) {\n    border-left: none;\n  }\n}\n\n/* Config strip as its own soft card */\n.configCard {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fff;\n  border-radius: var(--radius-card);\n  box-shadow: var(--shadow1);\n  color: var(--text-lighter);\n  font-size: 0.8125rem;\n  flex-wrap: wrap;\n}\n.configInfo {\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--blue-bg);\n  color: var(--blue);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.configInfo svg {\n  width: 15px;\n  height: 15px;\n}\n\n/* Needs-attention icon */\n.attnIcon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: var(--red-bg);\n  color: var(--red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.attnIcon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.notice {\n  font-size: 0.8125rem;\n  padding: 10px 14px;\n  border-radius: 6px;\n  margin-top: 12px;\n}\n.noticeInfo {\n  background: var(--blue-bg);\n  color: var(--text-light);\n}\n.noticeError {\n  background: var(--red-bg);\n  color: var(--red);\n}\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Stats block */\n.stats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px 24px;\n}\n@media (max-width: 720px) {\n  .stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n.stat {\n  min-width: 0;\n}\n/* One line, always. The tile caption names the results window, and the full label\n   (\"since enabled Sep 14, 8:00 AM EDT\") wrapped to two and three lines inside this 4-column\n   grid: the four captions ended up different heights, the values under them left their shared\n   baseline, and the row pushed the card open. The caption is shortened at the source too\n   (Presentation/windowCaption.ts) — this clamp is the backstop for a long stat label in a narrow\n   column, and every label that can hit it carries a `title` so the clamp never hides the text. */\n.statLabel {\n  color: var(--text-lighter);\n  font-size: 0.8125rem;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.statValue {\n  font-weight: 700;\n  font-size: 1.75rem;\n  line-height: 1.15;\n  margin-top: 8px;\n}\n.experimentLine {\n  color: var(--text-lighter);\n  font-size: 0.75rem;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid var(--n-lightest);\n}\n.statValueAlert {\n  color: var(--red);\n}\n.statValueGood {\n  color: var(--theme);\n}\n\n.muted {\n  color: var(--text-lighter);\n}\n.small {\n  font-size: 0.75rem;\n}\n.strong {\n  font-weight: 500;\n}\n\n/* Tables */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.table th {\n  padding: 14px 12px 12px;\n  color: var(--text-lighter);\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-align: left;\n  vertical-align: bottom;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n.table th:first-child,\n.table td:first-child {\n  padding-left: 20px;\n}\n.table th:last-child,\n.table td:last-child {\n  padding-right: 20px;\n}\n.table td {\n  padding: 16px 12px;\n  font-size: 0.875rem;\n  vertical-align: middle;\n}\n.table tbody tr {\n  box-shadow: inset 0 -1px 0 0 var(--a8);\n}\n.table tbody tr.zebra:nth-child(even) {\n  background: var(--a2);\n}\n.clickable {\n  cursor: pointer;\n}\n.clickable:hover {\n  background: var(--a4);\n}\n\n/* Filter chips */\n.filters {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n.chip {\n  padding: 6px 12px;\n  border-radius: 9999px;\n  border: 1px solid var(--n-lighter);\n  background: #fff;\n  cursor: pointer;\n  font-size: 0.75rem;\n  font-family: inherit;\n  color: var(--text);\n}\n.chip:hover {\n  background: var(--a4);\n}\n.chip:focus-visible {\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n.chip:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.chipActive {\n  background: var(--text);\n  color: #fff;\n  border-color: var(--text);\n}\n/* An active chip must stay dark on hover — without this, the generic\n   .chip:hover (same specificity, declared earlier is overridden but a\n   pseudo-class variant later wins) turned the background light while the\n   label stayed white: white-on-white text. */\n.chipActive:hover {\n  background: var(--text);\n}\n/* Long dynamic client names wrap instead of overflowing. */\n.chip {\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  text-align: left;\n}\n.chipCnt {\n  color: var(--text-lighter);\n  margin-left: 6px;\n}\n.chipActive .chipCnt {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Collapsible cards */\n.collapse {\n  background: var(--white);\n  border-radius: var(--radius-card);\n  box-shadow: var(--shadow1);\n}\n.collapse > summary {\n  padding: 20px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  list-style: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.collapse > summary::-webkit-details-marker {\n  display: none;\n}\n.collapse > summary::before {\n  content: '▸';\n  color: var(--text-lighter);\n  font-size: 0.75rem;\n}\n.collapse[open] > summary::before {\n  content: '▾';\n}\n\n/* Modal */\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(9, 30, 66, 0.54);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 40px 16px;\n  overflow: auto;\n  /* Must beat the Agency shell's sidebar/nav stacking (observed above 1300\n     in-browser): with a lower value, sidebar links stay clickable \"through\"\n     an open modal and navigate away. */\n  z-index: 10000;\n}\n.modal {\n  background: #fff;\n  border-radius: var(--radius-card);\n  box-shadow: 0 8px 16px rgba(9, 30, 66, 0.16);\n  width: 100%;\n  max-width: 900px;\n}\n.modalSm {\n  max-width: 420px;\n}\n.modalHeader {\n  padding: 20px;\n  border-bottom: 1px solid var(--n-lightest);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n.modalHeader h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--theme);\n}\n.x {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  cursor: pointer;\n  color: var(--text-lighter);\n  line-height: 1;\n  padding: 0;\n}\n\n/* Eligibility checks */\n.checks {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: 10px 24px;\n}\n.check {\n  display: flex;\n  gap: 8px;\n  align-items: baseline;\n}\n.checkFail {\n  color: var(--red);\n  font-weight: 500;\n}\n.tick {\n  color: var(--theme);\n  font-weight: 700;\n}\n.cross {\n  color: var(--red);\n  font-weight: 700;\n}\n\n/* Horizontal-scroll container so wide tables never break the page. */\n.tableScroll {\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n/* The funnel stage the run is currently at. */\n.funnelActive {\n  color: var(--text);\n  font-weight: 700;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n/* Funnel */\n.funnel {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  color: var(--text-light);\n}\n.funnel b {\n  font-weight: 600;\n  color: var(--text);\n}\n.arrow {\n  color: var(--text-lightest);\n}\n\n/* Timeline */\n.timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.timeline li {\n  display: flex;\n  gap: 16px;\n  padding: 6px 0;\n}\n.timeline .t {\n  color: var(--text-lighter);\n  font-variant-numeric: tabular-nums;\n  min-width: 72px;\n  font-size: 0.75rem;\n  padding-top: 2px;\n}\n\n/* Signals / key-value grid */\n.sig {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 12px;\n  background: var(--a2);\n  padding: 16px 20px;\n}\n.sigFlush {\n  background: none;\n  padding: 0;\n}\n.sig .k {\n  color: var(--text-lighter);\n  font-size: 0.75rem;\n}\n.sig .v {\n  font-weight: 500;\n}\n\n/* Safety invariant — belongs to the prototype visual language */\n.attention {\n  border-left: 3px solid var(--red);\n}\n.safety {\n  border-left: 3px solid var(--theme);\n}\n.safetyBreach {\n  border-left: 3px solid var(--red);\n}\n.safetyStop {\n  background: var(--red);\n  color: #fff;\n  font-weight: 700;\n  font-size: 1rem;\n  padding: 12px 16px;\n  border-radius: var(--radius-card);\n  margin-bottom: 16px;\n}\n.safetyStop span {\n  font-weight: 400;\n  font-size: 0.8125rem;\n}\n\n/* Reduced motion: content still updates (countdown text), but nothing\n   animates or transitions. */\n@media (prefers-reduced-motion: reduce) {\n  .page *,\n  .overlay * {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n/* --- Settings editor / audit / ranking-evidence additions (additive) --- */\n.input {\n  border: 1px solid var(--n-lighter);\n  border-radius: 4px;\n  padding: 6px 10px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  color: var(--text);\n  background: #fff;\n}\n.input:focus-visible {\n  outline: 2px solid var(--theme);\n  outline-offset: 1px;\n}\n.rankingList {\n  margin: 8px 0 0;\n  padding-left: 20px;\n  font-size: 0.875rem;\n}\n.rankingList li {\n  margin-top: 6px;\n}\n.rankingLocked {\n  color: var(--text-light);\n}\n.rankingLocked em {\n  font-style: normal;\n  font-size: 0.8125rem;\n  color: var(--text-light);\n}\n.previewControl {\n  background: rgba(9, 30, 66, 0.04);\n  border-radius: 4px;\n  padding: 8px 12px;\n  display: inline-block;\n}\n.formErrors {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-left: 3px solid var(--red);\n  background: rgba(222, 53, 11, 0.06);\n  font-size: 0.875rem;\n}\n.whyCell {\n  max-width: 260px;\n}\n\n/* Job-title deep link in the modal header. Hover and keyboard focus get the\n   SAME visible treatment: the previous pointer-only inline handlers never\n   fired for keyboard users, so tabbing to the link showed no cue. */\n.jobTitleLink {\n  color: inherit;\n  text-decoration: none;\n}\n.jobTitleLink:hover {\n  text-decoration: underline;\n}\n.jobTitleLink:focus-visible {\n  text-decoration: underline;\n  outline: 2px solid var(--blue);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export var page = `iqPQsPMiVvtnln8MAsnS`;
export var overlay = `y04LaWVfcwjBptznHTgK`;
export var pageHeader = `_RkqzkcZwafRoIZ5LX8c`;
export var title = `Lz1fSHW9l4DcTL5mWoUN`;
export var subtitle = `gxkkvJV8qaR5WL8ITlSi`;
export var headerControls = `nUww7B5GQ1ijwOJoHuOF`;
export var content = `yoHS3gk_hhkysYP4X4NO`;
export var card = `TgCNSHYwEubDGA6QkBzC`;
export var cardHeader = `AaTYFAhghW0lWyV0Zh9Q`;
export var section = `Soqru8tj2e4vxXjqI3A1`;
export var sectionSubdued = `MF6Puco1HzKPsSXQV4m4`;
export var badge = `VFPDVSDQXcYwFTNV6Z0w`;
export var blue = `_MAks52NZYih2rWMI8h6`;
export var green = `l8c7jz9MD6eQajCpGrB3`;
export var amber = `A3HFEC2ULt3oxCklpCwD`;
export var red = `bTW3uKe3pYcsJFeRuUYo`;
export var btn = `ddkJ1VOHoblXV4NYFOzS`;
export var btnOutline = `nmo4D5owhES48iBDxZyG`;
export var btnDanger = `FYI1GEcx0ZzXBLg1UVGP`;
export var btnSm = `u3DhueCPJ1yhb08_tIt8`;
export var btnPlain = `UaAVjv9R_bwqsIfbwgpA`;
export var modeToggle = `e3rK6UGdhdCGvyclC1Oz`;
export var modeBtn = `oQvK5TrI_0c7Na0BnM2_`;
export var locked = `k4Xhv0ppGL_UbnERZbYw`;
export var active = `on3RLOK3ZAhEsegYj5q8`;
export var activeOff = `BVeUFPxrSxT3753BRElq`;
export var activeShadow = `KawrcAvqi59k4O9i57Rw`;
export var stateDot = `o9JfJLQgNioKypOYUuxN`;
export var stateDotOff = `ceWhBRCjN5Ot5pKQZx8y`;
export var stateDotShadow = `gBOF7JcxvcO5yzm2x_hz`;
export var pulse = `VySJIqQkrqpYn2vLIcYG`;
export var stateDotRunning = `XU3PTfLI2v_sbHWFzbSe`;
export var statusGroup = `dq0z8ainfNshCK84jHtq`;
export var statusItem = `rZJz8vXwF1vK4U2OFnrg`;
export var statusKey = `PiWjHTd2LipqZOTm8cNk`;
export var statusVal = `A_wt52HLZ1LbK9hif5oJ`;
export var statusRunning = `J3MAhIUL9B2_w_5B2DFe`;
export var statusStopped = `OuanVmrvdzvFgxAmBsq9`;
export var modeLock = `wyXt9xICZwZS94LfYZCb`;
export var segToggle = `sRsuYJJ1ULqfEXYFAjRw`;
export var segBtn = `qdB8AtLbeuYnpe1c0Stz`;
export var segActive = `de1OCLweOkiz8WlDhAE7`;
export var segActiveOff = `fRNRcibr2Yj_2vhtaI4o`;
export var segActiveShadow = `w5jBGEtyZn3JLmZZeDMa`;
export var segLocked = `HZQhY3IjPEV1p7T_YYSD`;
export var statusUnder = `uRQvlaaac6WS_JqZe_HU`;
export var dot = `hM1etvtBwl8xWGaHeoBb`;
export var statusOff = `dwKNkpc1zkVyd7MbM33j`;
export var statusShadow = `in7TpFAQCK_Cb_g1oS2A`;
export var statusLive = `kAPgPw6xzgtwl5hjsIF2`;
export var btnIcon = `ahLu5qFd2GH4DJEVW0gN`;
export var kpiCard = `nvaT9ZlDqXVNSzHOrGXb`;
export var kpiItem = `svnn9LCv4ITMmdF_QAq5`;
export var kpiIcon = `I5uz3H9FMnKrtAhgkPjR`;
export var kpiIconGreen = `KC5OcbBLxl6rbiMZyPpA`;
export var kpiIconBlue = `ll7gl4mklw4jXeF3UkQk`;
export var kpiIconAmber = `mxyk3hmhxhTW4GXKP7rQ`;
export var kpiIconRed = `MWNa94GvAOZD7nx_ES45`;
export var kpiLabel = `HmCK4L3FLwfnBIi4tksd`;
export var kpiNum = `XxMIzD6yx862ei3vkkPt`;
export var kpiNumAlert = `EJ6fPo62znOhONnS9us9`;
export var configCard = `widv50eVMeQd9xUIjvoe`;
export var configInfo = `znXQTsZ0R2cChF11Ug8y`;
export var attnIcon = `g1VbfMKg250EBgYtp3o4`;
export var notice = `RYhUeEPLHzCrQ86DI8tL`;
export var noticeInfo = `N4D0maocV5GnypEqMW9d`;
export var noticeError = `sWYV30spXtOG8lsKKBGZ`;
export var stats = `HRHbImO4Ffz98ZcvjqEb`;
export var stat = `MUkrxKpmk0izmCtEW0yj`;
export var statLabel = `Uxyd6AhAnsUUMaZ0szQ5`;
export var statValue = `BbqhQEwymDhF2ZhtHRjq`;
export var experimentLine = `H8HnQu5w37axwPtlVQ3g`;
export var statValueAlert = `goElx0UxWwAlzfunv56e`;
export var statValueGood = `xtNlC6bFI3dXixDsyqcz`;
export var muted = `Dvon1fkXPdZLwQwQsUH1`;
export var small = `wYnmMmEEXZ4t9lUeiHuB`;
export var strong = `dBy9lDKjT8BEJcnjNA25`;
export var table = `xqp6da11VtevcO0IQelv`;
export var zebra = `kF2Bu4pxrCaIQvPdKFlo`;
export var clickable = `Zgv30rGKdaOU8JWJU4gv`;
export var filters = `oncUpbSkKTMz3d6ZvTzO`;
export var chip = `BBdyGq8wWPA4Yi8wF0wP`;
export var chipActive = `asiy6DkuC87C9y0cg8nU`;
export var chipCnt = `fTBFkncxFmoSE0ao0FAF`;
export var collapse = `CJfjcYtspTPqLFLZE9Mz`;
export var modal = `nS4ogvr0tWTB2vUHMt4j`;
export var modalSm = `xOizhGeU26W8u8CqNFIy`;
export var modalHeader = `l93dmGQEoGHkKOASVTIZ`;
export var x = `hN4bCULhQ9Q5LP5euot2`;
export var checks = `F4alnrInSo9CeBa0egT8`;
export var check = `dJoKqAPO6ks1C7cjbX_w`;
export var checkFail = `JBYB5O4PobnfjUomKs_d`;
export var tick = `ukJ8JCGfbVo_75NbsRze`;
export var cross = `eTd7rdJP0ZUFbQjzkkqw`;
export var tableScroll = `cV2JR15y9Yx5xRWjeAnR`;
export var funnelActive = `yRgFNaWMmF5i8N0UQiam`;
export var funnel = `ocbfGao_2c7vyHajd4YO`;
export var arrow = `dbOpLTIGeRF4OP6Ax9IM`;
export var timeline = `nVFCKeVXtZMBV_HLdCKh`;
export var t = `QETBNtPpJGHtfT3e3Rhy`;
export var sig = `YVlTLLx0s3laGhsFXZrQ`;
export var sigFlush = `topTdRKp1tPmVWEYWyx2`;
export var k = `Ky9EP0_AAv700QZjpKov`;
export var v = `dgzXm0Rio_MzEjLuVG6U`;
export var attention = `GDpZV0SVHiEa0Q6d2llL`;
export var safety = `EV5Rq64WvgOuaHLjetkj`;
export var safetyBreach = `dMmY3VKXQMN6GSNNplEQ`;
export var safetyStop = `uZVUQLmMHuhhhDoVuydV`;
export var input = `O6wS22CxwDfjTZRDGhM3`;
export var rankingList = `yafq7YgoHToLytMn_1m9`;
export var rankingLocked = `pmcFmimKJ5f7DLWX6lC9`;
export var previewControl = `Ir22rM1OLT4SSsCUkU2s`;
export var formErrors = `VPQB_RzFVcjl1Y1ePFSA`;
export var whyCell = `Wk8YEGOvZ3VQmyh_40xD`;
export var jobTitleLink = `VHuuTh14h0pnW9uEWIem`;
export default ___CSS_LOADER_EXPORT___;
